import React from 'react';
import { CardData } from '../card';
import { Service } from '../../../../../hoc/context/product/context-model';
import CardLeftView from '../card/views/card-left-view';

const CardLeft: React.FC<{
	service: Service;
	data: CardData;
	printMode?: boolean;
}> = ({ service, printMode = false }) => {
	return (
		<CardLeftView
			service={service}
			defaultClassName={
				'rounded-bl-2xl rounded-tl-2xl flex flex-col justify-center items-center px-4'
			}
			titleClassName={'flex flex-col [&_span]:text-8xl'}
			printMode={printMode}
		/>
	);
};

export default CardLeft;
